import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
const ACCESS_TOKEN = 'ACCESS_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const REDIRECT_URL = 'REDIRECT_URL';
const LOGIN = 'LOGIN';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  isBrowser: boolean;
  private readonly LOGIN_KEY = 'LOGIN';
  // Initialize BehaviorSubject with the value from sessionStorage
  private loginStatusSubject = new BehaviorSubject<boolean>(false);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  getToken() {
    if (this.isBrowser) {
      return sessionStorage.getItem(ACCESS_TOKEN);
    }
    return null;
  }

  getLogin() {
    const loginValue = this.isBrowser ? sessionStorage.getItem(this.LOGIN_KEY) : null;
    const isLoggedIn = loginValue === 'true'
    this.loginStatusSubject.next(isLoggedIn);
    return isLoggedIn; 
  }

  // Method to expose login status as observable
  getLoginStatusObservable() {
    return this.loginStatusSubject.asObservable();
  }

  postWithoutToken() {
    if (this.isBrowser) {
      return sessionStorage.getItem(REFRESH_TOKEN);
    }
    return null;
  }

  saveToken(token: any) {
    if (this.isBrowser) {
      sessionStorage.setItem(ACCESS_TOKEN, token);
      this.saveLogin(true);
    }
  }

  saveLogin(isLoggedIn: boolean): void  {
    if (this.isBrowser) {
      this.loginStatusSubject.next(isLoggedIn);
      sessionStorage.setItem(this.LOGIN_KEY, isLoggedIn.toString());
    }
  }

  saveRefreshToken(refreshToken: any) {
    if (this.isBrowser) {
      sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
    }
  }

  getLocationId() {
    if (this.isBrowser) {
      return sessionStorage.getItem('locationId');
    }
    return null;
  }

  getLanguage() {
    if (this.isBrowser) {
      return localStorage?.getItem('locale') || 'en';
    }
    return null;
  }

  getUserInfo() {
    if (this.isBrowser) {
      return sessionStorage.getItem('id_token_claims_obj');
    }
    return null;
  }

  removeToken() {
    if (this.isBrowser) {
      sessionStorage.removeItem(ACCESS_TOKEN);
    }
  }

  removeLogin() {
    if (this.isBrowser) {
      sessionStorage.removeItem(LOGIN);
      this.removeStemplingEnabled();
    }
  }

  saveStemplingEnabled(enabled: any) {
    if (this.isBrowser) {
      sessionStorage.setItem('isStemplingEnabled', String(enabled === true));
    }
  }

  isStemplingEnabled(): boolean {
    if (this.isBrowser) {
      return sessionStorage.getItem('isStemplingEnabled') === 'true';
    }
    return false;
  }

  removeStemplingEnabled() {
    if (this.isBrowser) {
      sessionStorage.removeItem('isStemplingEnabled');
    }
  }

  removeRefreshToken(): void {
    if (this.isBrowser) {
      sessionStorage.removeItem(REFRESH_TOKEN);
    }
  }

  setRedirectUrl(url: any): void {
    if (this.isBrowser) {
      sessionStorage.setItem(REDIRECT_URL, url);
    }
  }

  getRedirectUrl() {
    if (this.isBrowser) {
      return sessionStorage.getItem(REDIRECT_URL);
    }
    return null;
  }

  removeRedirectUrl(): void {
    sessionStorage.removeItem(REDIRECT_URL);
  }

  getLocale() {
    if (this.isBrowser) {
      return sessionStorage.getItem('locale');
    }
    return null;
  }
}
